var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{attrs:{"card-body-classes":"table-full-width"}},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Call records")]),_c('CDRTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }